export { default as Home } from './Home';
export { default as NotFound } from './NotFound';
export { default as DisplayError } from './DisplayError';



// WEBPACK FOOTER //
// ./src/modules/root/pages/index.js